import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../../services/api";
import "./hostel.css";

export default function HostelList() {
  const school = JSON.parse(localStorage.getItem("schoolAdmin"));
  const navigate = useNavigate();

  const [hostels, setHostels] = useState([]);
  const [loading, setLoading] = useState(false);

  // ============================
  // LOAD HOSTELS
  // ============================
  const loadHostels = async () => {
    try {
      setLoading(true);
      const res = await API.get("/school-admin/hostels/", {
        headers: { "X-SCHOOL-ID": school.school.id },
      });
      setHostels(res.data.hostels || []);
    } catch (err) {
      console.error("Failed to load hostels", err);
      alert("Failed to load hostels");
    } finally {
      setLoading(false);
    }
  };

  // ============================
  // DELETE HOSTEL
  // ============================
  const deleteHostel = async (id) => {
    if (!window.confirm("Are you sure you want to delete this hostel?"))
      return;

    try {
      await API.delete(`/school-admin/hostels/${id}/`, {
        headers: { "X-SCHOOL-ID": school.school.id },
      });

      // Remove from state instantly (better UX)
      setHostels((prev) => prev.filter((h) => h.id !== id));
    } catch (err) {
      console.error("Delete failed", err);
      alert("Failed to delete hostel");
    }
  };

  useEffect(() => {
    loadHostels();
  }, []);

  const totalRooms = hostels.reduce((a, h) => a + (h.total_rooms || 0), 0);

  return (
    <div className="hostel-page-wrap">

      {/* HERO */}
      <div className="hostel-hero">
        <div className="hostel-hero-left">
          <span className="hostel-hero-icon">🏠</span>
          <div>
            <h1>Hostel Management</h1>
            <p>{hostels.length} hostel{hostels.length !== 1 ? "s" : ""} registered</p>
          </div>
        </div>
        <div className="hostel-hero-action">
          <button
            className="hostel-add-btn"
            onClick={() => navigate("/school-admin/hostels/add")}
          >
            + Add Hostel
          </button>
        </div>
      </div>

      {/* STATS */}
      <div className="hostel-stats">
        <div className="hostel-stat-card">
          <span>Total Hostels</span>
          <strong>{hostels.length}</strong>
        </div>
        <div className="hostel-stat-card">
          <span>Total Rooms</span>
          <strong>{totalRooms}</strong>
        </div>
        <div className="hostel-stat-card">
          <span>Quick Action</span>
          <strong
            style={{ fontSize: "14px", cursor: "pointer", color: "#1d5fa8" }}
            onClick={() => navigate("/school-admin/hostels/allocate")}
          >
            → Assign Student
          </strong>
        </div>
      </div>

      {/* CONTENT */}
      {loading ? (
        <div className="hostel-loading">
          <div className="hostel-spinner" />
        </div>
      ) : hostels.length === 0 ? (
        <div className="hostel-empty">
          <span style={{ fontSize: "48px" }}>🏠</span>
          <p>No hostels added yet. Click <b>+ Add Hostel</b> to get started.</p>
        </div>
      ) : (
        <div className="hostel-grid">
          {hostels.map((h) => (
            <div className="hostel-card-new" key={h.id}>
              <div className="hostel-card-top">
                <div className="hostel-card-ico">🏠</div>
                <div>
                  <h3>{h.name}</h3>
                  <p>{h.warden_name ? `Warden: ${h.warden_name}` : "No warden assigned"}</p>
                </div>
              </div>
              <div className="hostel-card-body">
                <div className="hostel-info-row">
                  <span>Total Rooms</span>
                  <span>{h.total_rooms ?? 0}</span>
                </div>
                {h.hostel_fee_amount > 0 && (
                  <div className="hostel-info-row">
                    <span>Monthly Fee</span>
                    <span>₹{h.hostel_fee_amount}</span>
                  </div>
                )}
              </div>
              <div className="hostel-card-footer">
                <button
                  className="btn-manage"
                  onClick={() => navigate(`/school-admin/hostels/${h.id}/rooms`)}
                >
                  Manage Rooms
                </button>
                <button className="btn-del" onClick={() => deleteHostel(h.id)}>
                  Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}